<script lang="ts">
	export let stepLength = 4;
	export let stepNow = 1;

	$: stepArray = new Array(stepLength).fill(null).map((_, index) => index + 1);

</script>

<div class="wrapper">
	{#each stepArray as step}
		<div class:checked={step <= stepNow} class="step">
			{#if stepLength === step}
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="14.367"
					height="10.737"
					viewBox="0 0 14.367 10.737">
					<g data-name="그룹 48988">
						<path
							data-name="패스 310"
							d="M-1290.005 272.709a.479.479 0 0 1-.343-.145l-4.1-4.21a.478.478 0 0 1 .009-.677.479.479 0 0 1 .677.009l3.754 3.854 8.422-8.875a.479.479 0 0 1 .677-.018.479.479 0 0 1 .018.677l-8.765 9.236a.478.478 0 0 1-.344.149z"
							transform="translate(1294.835 -262.222)"
							style="stroke-width:.5px" />
					</g>
				</svg>
			{:else}
				<div class="text">{step}</div>
			{/if}
		</div>
		{#if step !== stepLength}
			<div class="bar">
				<div class="progress" class:done={step <= stepNow - 1} />
			</div>
		{/if}
	{/each}
</div>

<style lang="scss">
	div {
		&.bar {
			flex-grow: 1;
			height: 3px;
			background-color: #e6e7ed;

			.progress {
				width: 0%;
				height: 100%;

				&.done {
					animation: progrss linear 0.2s;
					background-color: #6591fa;
					width: 100%;
				}
			}
		}

		&.wrapper {
			position: relative;
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			height: 100%;
		}

		&.step {
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			width: 26px;
			height: 26px;
			border-radius: 100%;

			color: #bcbfc3;
			z-index: 1;
			&:not(:first-child) {
				transition: all 0.5s;
				background: linear-gradient(to left, #e6e7ed 50%, #6591fa 50%);
				background-size: 400% 400%;
				background-position: 100% 50%;
				&.checked {
					animation: stepBox 0.5s linear forwards;
					.text {
						animation: text 0.2s linear forwards;
						animation-delay: 0.2s;
					}

					svg g path {
						animation: check 0.2s linear forwards;
						animation-delay: 0.2s;
					}
				}
				/* #bcbfc3 */
			}
			svg g path {
				fill: #bcbfc3;
				stroke: #bcbfc3;
			}

			.text {
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			&:first-child {
				background-color: #6591fa;
				color: white;
			}
		}
	}

	@keyframes stepBox {
		0% {
			background-position: 100% 50%;
		}

		100% {
			background-position: 0% 50%;
		}
	}

	@keyframes progrss {
		0% {
			width: 0%;
		}

		100% {
			width: 100%;
		}
	}

	@keyframes text {
		0% {
			color: bcbfc3;
		}
		100% {
			color: white;
		}
	}

	@keyframes check {
		0% {
			fill: #bcbfc3;
			stroke: #bcbfc3;
		}
		100% {
			fill: white;
			stroke: white;
		}
	}

</style>
